import { Box, Typography } from "@mui/material";
import * as DecisionBaseModal from "components/pages/game/decision-modals/DecisionBaseModal";
import * as GameCard from "components/pages/game/GameCard";
import { CardType } from "models/CardType";
import React from "react";

export interface Props {
  cards: CardType[];
  isOpen: boolean;
  onClose: () => void;
}

export const Component: React.FC<Props> = ({ cards, isOpen, onClose }) => {
  const renderContent = () => {
    return (
      <div>
        <Typography variant="body1">Confirm purchasing these cards.</Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
          {cards
            .filter((card) => !card.isCorporation)
            .map((card) => (
              <Box key={card.name} className="card-container">
                <GameCard.Component
                  name={card.name}
                  isCorporation={card.isCorporation}
                  isPrelude={card.cardType === "PRELUDE"}
                  tooltip={card.tooltip}
                />
              </Box>
            ))}
        </Box>
      </div>
    );
  };

  return (
    <DecisionBaseModal.Component
      content={renderContent()}
      isOpen={isOpen}
      onClose={onClose}
      ActionData={{
        cards: cards.map((c) => c.name),
      }}
      ActionId="PURCHASE_CARDS"
      DecisionId="DRAFT_CARDS"
    />
  );
};

Component.displayName = "PurchaseCardsModal";
